module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGF01-7e0d3f7fe230a7ae4cfe639e1009c904.png";